import { prodApiConfig, devApiConfig, paymentPage } from '../../config/api.config';

const { SPAY_PROD_SERVER, SPAY_PROD_COLLECTIONS, SPAY_PROD_SETTLEMENT } = prodApiConfig;
const { SPAY_TEST_SERVER, SPAY_TEST_COLLECTIONS, SPAY_TEST_SETTLEMENT } = devApiConfig;
const { PAYMENT_PAGE, PAYMENT_PAGE_URL_NAME } = paymentPage;

export const paymentPageApi = PAYMENT_PAGE;
export const paymentPageUrlName = PAYMENT_PAGE_URL_NAME;

export enum Mode {
    LIVE = 'LIVE',
    TEST = 'TEST'
}

const VALIDATED_MODE = 'LIVE';

console.log(SPAY_PROD_SETTLEMENT);

export const getPaymentPage = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}pay/page/`;
        default:
            return `${SPAY_TEST_SERVER}pay/page/`;
    }
};

export const getInvoicePage = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}pay/invoice/`;
        default:
            return `${SPAY_TEST_SERVER}pay/invoice/`;
    }
};

export const getActiveMode = (explicitMode?: Mode | string): Mode => {
    if (explicitMode === Mode.LIVE || explicitMode === 'LIVE') return Mode.LIVE;
    if (explicitMode === Mode.TEST || explicitMode === 'TEST') return Mode.TEST;

    try {
        const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('modeType') : null;
        if (stored === Mode.LIVE || stored === 'LIVE') return Mode.LIVE;
        if (stored === Mode.TEST || stored === 'TEST') return Mode.TEST;
    } catch (e) {
        // localStorage not available
    }

    if (typeof window !== 'undefined' && window.location) {
        const hostname = (window.location.hostname || '').toLowerCase();
        if (
            hostname === 'dashboard.spaybusiness.com' ||
            hostname === 'spaybusiness.com' ||
            hostname === 'merchants.spaybusiness.com' ||
            hostname.endsWith('.spaybusiness.com')
        ) {
            return Mode.LIVE;
        }
    }

    return Mode.LIVE;
};

export const accessTokenUrl = (mode?: Mode | string) => {
    const activeMode = getActiveMode(mode);
    switch (activeMode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}oauth/token`;
        default:
            return `${SPAY_TEST_SERVER}oauth/token`;
    }
};

export const loginUserUrl = (mode?: Mode | string) => {
    const activeMode = getActiveMode(mode);
    switch (activeMode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}oauth/token`;
        default:
            return `${SPAY_TEST_SERVER}oauth/token`;
    }
};

export const requestPasswordResetUrl = (mode?: Mode | string) => {
    const activeMode = getActiveMode(mode);
    switch (activeMode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/users/forgot-password`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/users/forgot-password`;
    }
};

export const createNewPasswordUrl = (mode?: Mode | string) => {
    const activeMode = getActiveMode(mode);
    switch (activeMode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/users/change-password`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/users/change-password`;
    }
};

export const changePasswordUrl = (mode?: Mode | string) => {
    const activeMode = getActiveMode(mode);
    switch (activeMode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/users/reset-password`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/users/reset-password`;
    }
};

export const verifyUserEmailUrl = (mode?: Mode | string) => {
    const activeMode = getActiveMode(mode);
    switch (activeMode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/users/verify-email`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/users/verify-email`;
    }
};

export const resendEmailVerificationUrl = (mode?: Mode | string) => {
    const activeMode = getActiveMode(mode);
    switch (activeMode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/users/resend-verification-email`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/users/resend-verification-email`;
    }
};

// SECTION : Merchant API Selector -->

/* User Controller -> */

export const getUserProfileUrl = (mode: Mode, id: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/users/${id}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/users/${id}`;
    }
};

export const updateUserProfileUrl = (mode: Mode, id: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/users/${id}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/users/${id}`;
    }
};

export const updatePasswordUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/users/change-password`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/users/change-password`;
    }
};

/* Role Controller -> */

/* State Controller -> */

/* Plan Controller -> */

export const plansUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/plans`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/plans`;
    }
};

export const planIdUrl = (mode: Mode, planId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/plans/${planId}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/plans/${planId}`;
    }
};

export const subscriptionsUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/subscribe`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/subscribe`;
    }
};

export const subscriptionByIdUrl = (mode: Mode, subscriptionId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/subscribe/${subscriptionId}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/subscribe/${subscriptionId}`;
    }
};

export const subscriptionCancelUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/subscribe/cancel`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/subscribe/cancel`;
    }
};
/* Payment Link Controller -> */

export const getPaymentLinkUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/payment-links`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/payment-links`;
    }
};

export const checkLinkAvailableUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/payment-links/check-availability`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/payment-links/check-availability`;
    }
};

export const createPaymentLinkUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/payment-links`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/payment-links`;
    }
};

export const singlePaymentLinkUrl = (mode: Mode, paymentLinkId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/payment-links/${paymentLinkId}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/payment-links/${paymentLinkId}`;
    }
};

export const publishLinkUrl = (mode: Mode, paymentLinkId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/payment-links/${paymentLinkId}/publish`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/payment-links/${paymentLinkId}/publish`;
    }
};

/* Merchant Controller -> */

export const createMerchantUrl = (mode?: Mode | string) => {
    const activeMode = getActiveMode(mode);
    switch (activeMode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants`;
    }
};

export const createDevUserUrl = (mode?: Mode | string) => {
    return createMerchantUrl(mode);
};

export const createProdUserUrl = () => {
    return `${SPAY_PROD_SERVER}api/v1/merchants`;
};

export const addNewBusinessUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/add-new-merchant`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/add-new-merchant`;
    }
};

export const updateMerchantDetailsUrl = (mode: Mode, merchantId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/${merchantId}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/${merchantId}`;
    }
};

export const merchantsOnboardingUrl = (mode: Mode, merchantId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants-onboarding/${merchantId}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants-onboarding/${merchantId}`;
    }
};

export const getMerchantDetailsUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants`;
    }
};

export const getMerchantDetailsByEmailUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/user-email`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/user-email`;
    }
};

export const getKycStatusUrl = (mode: Mode, merchantId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/${merchantId}/kyc-status`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/${merchantId}/kyc-status`;
    }
};

export const getKycTypesUrl = (mode: Mode, merchantId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/${merchantId}/kyc-types`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/${merchantId}/kyc-types`;
    }
};

export const getMerchantProfileUrl = (mode: Mode, id: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/${id}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/${id}`;
    }
};

export const uploadKycWithBVN = (mode: Mode, merchantId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/${merchantId}/upload-kyc/bvn`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/${merchantId}/upload-kyc/bvn`;
    }
};

export const uploadKycUrl = (mode: Mode, merchantId: string, kycTypeId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/${merchantId}/upload-kyc/${kycTypeId}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/${merchantId}/upload-kyc/${kycTypeId}`;
    }
};

export const uploadMerchantLogoUrl = (mode: Mode, merchantId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/${merchantId}/logo`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/${merchantId}/logo`;
    }
};




export const changeModeTypeUrl = () => `${SPAY_PROD_SERVER}api/v1/merchants/change-mode-type`;

export const getModeTypeUrl = () => `${SPAY_PROD_SERVER}api/v1/merchants/mode-type`;

// Invite Employee
export const inviteEmployeeUrl = (mode: Mode, merchantId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/${merchantId}/invites`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/${merchantId}/invites`;
    }
};

export const acceptInviteUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/invites/accept`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/invites/accept`;
    }
};

export const resendInviteUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/invite/resend`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/invite/resend`;
    }
};

export const suspendUserUrl = (mode: Mode, merchantId: string, userId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/${merchantId}/users/${userId}/status`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/${merchantId}/users/${userId}/status`;
    }
};

export const revokeInviteUrl = (mode: Mode, merchantId: string, email: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/${merchantId}/invites/revoke`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/${merchantId}/invites/revoke`;
    }
};

export const getInvitationUrl = (mode: Mode, merchantId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/${merchantId}/invites`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/${merchantId}/invites`;
    }
};

export const updateUserRoleUrl = (mode: Mode, merchantId: string, userId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/${merchantId}/users/${userId}/role`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/${merchantId}/users/${userId}/role`;
    }
};

//2FA

export const twoFaSetupUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/auth/2fa/setup`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/auth/2fa/setup`;
    }
};

export const twoFaEnableUrl = (mode: Mode, code: string | number) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/auth/2fa/enable?code=${code}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/auth/2fa/enable?code=${code}`;
    }
};

export const twoFaStatusUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/auth/2fa/status`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/auth/2fa/status`;
    }
};

export const twoFaDisableUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/auth/2fa/disable`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/auth/2fa/disable`;
    }
};

/* Invoice Controller -> */

export const invoiceUrl = (mode: Mode, path: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/invoice${path}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/invoice${path}`;
    }
};

export const downloadInvoiceCsvUrl = (mode: Mode, path: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/invoice/csv/download${path}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/invoice/csv/download${path}`;
    }
};

/* Customers Controller -> */

export const customersUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/customers`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/customers`;
    }
};

export const getCustomerDetailUrl = (mode: Mode, customerId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/customers/${customerId}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/customers/${customerId}`;
    }
};

export const downloadCustomerCsvUrl = (mode: Mode, value: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/customers/csv/download${value}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/customers/csv/download${value}`;
    }
};

/* Countries Controller -> */

export const getCountryUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/countries`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/countries`;
    }
};

export const getStateUrl = (mode: Mode, countryId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/countries/${countryId}/states`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/countries/${countryId}/states`;
    }
};

/* Bank Controller -> */

export const getBanksUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/banks/`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/banks/`;
    }
};

/* Bank Account Controller -> */

export const accountUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/bank-accounts`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/bank-accounts`;
    }
};

export const accountByIdUrl = (mode: Mode, bankAccountId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/bank-accounts/${bankAccountId}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/bank-accounts/${bankAccountId}`;
    }
};

/* Merchant categories --> */

export const getMerchantsCategoryUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchant-categories`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchant-categories`;
    }
};

/* Business Type Controller --> */

export const getAllBusinessTypesUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/business-types`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/business-types`;
    }
};

//  SECTION : Collections API Selector ->

export const paymentsUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_COLLECTIONS}api/v1/payments/filter`;
        default:
            return `${SPAY_TEST_COLLECTIONS}api/v1/payments/filter`;
    }
};

export const paymentDetailUrl = (mode: Mode, reference: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_COLLECTIONS}api/v1/payments/${reference}`;
        default:
            return `${SPAY_TEST_COLLECTIONS}api/v1/payments/${reference}`;
    }
};

export const overviewUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_COLLECTIONS}api/v1/payments/over-view`;
        default:
            return `${SPAY_TEST_COLLECTIONS}api/v1/payments/over-view`;
    }
};

export const downloadCsvUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_COLLECTIONS}api/v1/payments/csv/download`;
        default:
            return `${SPAY_TEST_COLLECTIONS}api/v1/payments/csv/download`;
    }
};

export const retriggerWebhookUrl = (mode: Mode, reference: string, tag: string) => {
    const isLocalhost =
        typeof window !== 'undefined' &&
        (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

    if (isLocalhost) {
        return `/collections-proxy/api/v1/wema/webhook/retry/${encodeURIComponent(reference)}?tag=${encodeURIComponent(tag)}`;
    }

    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_COLLECTIONS}api/v1/wema/webhook/retry/${encodeURIComponent(reference)}?tag=${encodeURIComponent(tag)}`;
        default:
            return `${SPAY_TEST_COLLECTIONS}api/v1/wema/webhook/retry/${encodeURIComponent(reference)}?tag=${encodeURIComponent(tag)}`;
    }
};

// SECTION : Settlements API Selector ->

export const payoutsUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SETTLEMENT}api/v1/settlements-summary`;
        default:
            return `${SPAY_TEST_SETTLEMENT}api/v1/settlements-summary`;
    }
};

export const singlePayoutsUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SETTLEMENT}api/v1/settlements/details`;
        default:
            return `${SPAY_TEST_SETTLEMENT}api/v1/settlements/details`;
    }
};

export const unsettledSettlementsUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_COLLECTIONS}api/v1/payments/settlements/unsettled`;
        default:
            return `${SPAY_TEST_COLLECTIONS}api/v1/payments/settlements/unsettled`;
    }
};

export const settlementsAnalyticsUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_COLLECTIONS}api/v1/payments/settlements/analytics`;
        default:
            return `${SPAY_TEST_COLLECTIONS}api/v1/payments/settlements/analytics`;
    }
};

export const downloadSettlementCsvUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SETTLEMENT}api/v1/settlements/download`;
        default:
            return `${SPAY_TEST_SETTLEMENT}api/v1/settlements/download`;
    }
};

// TODO: To be deleted -->
export const addBankAccountUrl = (mode: Mode, merchantId: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/merchants/${merchantId}/bank-accounts`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/merchants/${merchantId}/bank-accounts`;
    }
};

/* Direct Debit Controller endpount */

export const directDebitUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/direct-debit`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/direct-debit`;
    }
};

export const sendDirectDebitDraftUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/direct-debit/send-direct-draft`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/direct-debit/send-direct-draft`;
    }
};

export const getSingleDirectDebitUrl = (mode: Mode, slug: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/direct-debit/${slug}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/direct-debit/${slug}`;
    }
};

export const getDirectDebitStatusUrl = (mode: Mode, slug: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/direct-debit/status/${slug}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/direct-debit/status/${slug}`;
    }
};

export const scheduleCustomerDebitUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/direct-debit/schedule-customer-debit`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/direct-debit/schedule-customer-debit`;
    }
};

export const directDebitCancelUrl = (mode: Mode, slug: string) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/direct-debit/cancel-schedule/${slug}`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/direct-debit/cancel-schedule/${slug}`;
    }
};

// 2FA endpoints
export const twoFASetupUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/auth/2fa/setup`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/auth/2fa/setup`;
    }
};

export const twoFAEnableUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/auth/2fa/enable`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/auth/2fa/enable`;
    }
};

export const twoFAStatusUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/auth/2fa/status`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/auth/2fa/status`;
    }
};

export const twoFADisableUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/auth/2fa/disable`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/auth/2fa/disable`;
    }
};

// currency controller
export const getCurrencyUrl = (mode: Mode) => {
    switch (mode) {
        case VALIDATED_MODE:
            return `${SPAY_PROD_SERVER}api/v1/currencies`;
        default:
            return `${SPAY_TEST_SERVER}api/v1/currencies`;
    }
};
